import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const maxRatio = 1.6; // width/height

const getStylesFuncGenerator = ({ itemHeight }) => () => ({
  container: {
    minWidth: 180,
    maxHeight: itemHeight,
    height: itemHeight,
    margin: '5px',

    // if width is exceeding limit, will show center part and hide left/right
    maxWidth: itemHeight * maxRatio,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& img': {
      maxHeight: itemHeight,
    },
  },
});

const ImageSuggestionItemWrapper = ({ children, itemHeight }) => {
  const classes = useDefaultStyles(getStylesFuncGenerator({ itemHeight }));

  return (
    <div className={classes.container}>
      {children}
    </div>
  );
};

ImageSuggestionItemWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  itemHeight: PropTypes.number.isRequired,
};

export default ImageSuggestionItemWrapper;
